import *as TYPES from '../action-types';
let Home = {
    Clean(cleanValue) {
        return {
            type: TYPES.ClEAR_DATA,
            cleanValue
        };
    },

};
export default Home;


// WEBPACK FOOTER //
// ./src/store/actions/Home.js